import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Alert } from 'antd';

export const StyledMaxAttemptsMessage = styled(Alert)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    background: ${kcc.colors.BLACK};

    .error-icon {
      width: 24px;
      line-height: 1.6;
    }

    .ant-alert-message {
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      margin-bottom: ${kcc.spacing.XXS};
      color: ${kcc.colors.WHITE};
    }

    .ant-alert-description {
      font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};

      .ant-typography {
        color: ${kcc.colors.WHITE};
      }

      strong {
        font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      }
    }

    .ant-btn {
      color: ${kcc.colors.WHITE};
      font-size: ${kcc.typography.FONT_SIZE.BASE}px;
      border-color: ${kcc.colors.WHITE};

      &:hover {
        background-color: ${kcc.colors.BLACK} !important;
        color: ${kcc.colors.WHITE} !important;
        border-color: ${kcc.colors.WHITE} !important;
      }
    }
  `}
`;
